import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UmSummaryService, UserInfo } from 'src/app/services/um/um-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { UmUserViewModalComponent } from './um-user-view-modal/um-user-view-modal.component';
import { UmUserMapUserViewModalComponent } from './um-user-map-user-view-modal/um-user-map-user-view-modal.component';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-um-user',
  templateUrl: './um-user.component.html',
  styleUrls: ['./um-user.component.scss']
})
export class UmUserComponent implements OnInit {

  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  content: any;
  advanceSearch;
  collapesedOrNot: Boolean = false;
  userForm: UntypedFormGroup;
  Tempoperations: { name: string; id: string; }[];
  Tempoperations1: { name: string; id: string; }[];
  DepartmentList: any[] = [];
  RolesList: any[] = [];
  StatusList: any[] = [];
  isSettings: boolean = false;
  IsResendRequired: boolean = false;
  OrgDetail: any;
  UserName: string;
  ISANALYTICSCONFIGURED: boolean;
  ISORGACCOUNTINLOGI: boolean;
  constructor(
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
  ) {

  }

  ngOnInit() {
    this.getOrganisationDetailsbyID();

    this.StatusList.push({ label: "All", value: 101, checked: true });
    this.StatusList.push({ label: "Active", value: 1 });
    this.StatusList.push({ label: "Inactive", value: 0 });

    this.userForm = new UntypedFormGroup({

      TITLE: new UntypedFormControl(""),
      EMAIL: new UntypedFormControl(""),
      DEPARTMENT_ID: new UntypedFormControl(""),
      ROLEID: new UntypedFormControl(""),
      RECORD_STATE: new UntypedFormControl(101)

    });
    this.columnDefs = [
      {
        "headerName": "Username",
        "field": "TITLE",
      },
      {
        "headerName": "Department",
        "field": "DepartmentNames"
      },
      {
        "headerName": "Status",
        "field": "StatusExt"
      }
    ];

    this.getMasterData();
    this.ISANALYTICSCONFIGURED = this.OrgDetail.IS_ANALYTICS_CONFIGURED;
    this.ISORGACCOUNTINLOGI = this.OrgDetail.IS_ORG_ACCOUNT_IN_LOGI;
  }
  setRowOperations(rowData: any[]) {
 let viewPermission=this.commonService.getScreenPermission("104", "V");
 let editPermission=this.commonService.getScreenPermission("104", "E");
 let newPermission=this.commonService.getScreenPermission("104", "N");

    rowData.forEach(element => {
      this.Tempoperations = [];
      if (viewPermission) {
        this.isSettings = true;
        this.Tempoperations.push({
          "name": "View",
          "id": "view"
        });
      }
      if (editPermission) {
        this.isSettings = true;
        this.Tempoperations.push({
          "name": "Edit",
          "id": "edit"
        });
      }
      if (newPermission) {
        this.Tempoperations.push({
          "name": "Add User",
          "id": "add"
        });
      }
      
        if (element.IsTempPwd == "Yes" && element.StatusExt == "Active") {
          this.isSettings = true;
            this.Tempoperations.push({
              "name": "Resend Email ",
              "id": "Resend"
            });
        }
        if (this.OrgDetail.IS_ANALYTICS_CONFIGURED == true && this.OrgDetail.IS_ORG_ACCOUNT_IN_LOGI == true && element.IS_USER_LINKED_WITH_LOGI == false) {
          this.isSettings = true;
          this.Tempoperations.push({
            "name": "Refresh",
            "id": "Refresh"
          });

        }
        element["Operations"] = this.Tempoperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
    });
    this.operations = this.Tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    return rowData;
  }
  getMasterData() {
    this.summaryService.getUserSearchMaster().subscribe(summary => {

      this.DepartmentList = summary["MasterData1"];
      this.DepartmentList = [{ label: "All", value: "", checked: true }].concat(this.DepartmentList);
      this.RolesList = summary["MasterData2"];
      this.RolesList = [{ label: "All", value: "", checked: true }].concat(this.RolesList);

      var MailData = summary["MasterData3"][0];
      if (MailData != null) {
        this.IsResendRequired = MailData.value == "yes" ? true : false;
      }
      this.setSummary("-1");
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const Modalref = this.modalService.open(UmUserViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    Modalref.componentInstance.Content = {
      heading: 'Edit',
      content: { id: this.selectedRow['ID'] }
    };
    Modalref.result.then((result) => {
      this['self'].getSummaryData();
    });
  }

  add() {
    if (this['self'].IsResendRequired) {
      this['self'].summaryService.checkInternalUser("-1").subscribe(result => {
        if (result) {
          let modalRef = this['self'].modalService.open(UmUserViewModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-lg right modal-right',
            animation: true,
          });
          modalRef.componentInstance.Content = {
            heading: 'Add',
            content: null
          };
          modalRef.result.then((result) => {
            this['self'].setSummary("-1");
          });

        }
        else {

          this['self'].commonService.ValidationBanner("The User count has reached the limit set for organization. Kindly update the limit to save the user details");
        }
      });
    }
    else {
      this['self'].commonService.ValidationBanner("Please select email id in Outgoing Email Selection- Account Activities to add a user");
    }

  }

  edit(RecordData: any) {
    let modalRef = this['self'].modalService.open(UmUserViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['ID'], IsAnalyticsConfig: this['self'].ISANALYTICSCONFIGURED, IsOrgaccinLogi: this['self'].ISORGACCOUNTINLOGI }
    };
    modalRef.result.then((result) => {
      this['self'].setSummary("-1");
    });

  }
  view(RecordData: any) {
    let modalRef = this['self'].modalService.open(UmUserViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,

    });

    // modalRef.content.action.subscribe(result=>{
    //   this['self'].setSummary("-1");
    // })
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: RecordData['ID'], IsAnalyticsConfig: this['self'].ISANALYTICSCONFIGURED, IsOrgaccinLogi: this['self'].ISORGACCOUNTINLOGI }
    };
    modalRef.result.then((result) => {
      this['self'].setSummary("-1");
    });
  }

  map_roles(RecordData: any) {
    let modalRef = this['self'].modalService.open(UmUserMapUserViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['ID'] }
    }
    modalRef.result.then((result) => {
      // this['self'].setSummary("-1");
    });
  }


  setSummary(val) {
    this.SearchClear();
    this.summaryService.getUserSummary(val).subscribe(summary => {
      this.rowData = this.setRowOperations(summary);
    });
  }

  getOrganisationDetailsbyID() {
      ;
    this.summaryService.getOrganisationDetailsByID("-1").subscribe(result =>{
      if(result.Status == 0){
        this.OrgDetail = result.Data;
      }
    })
  }

  //// Advace search Functions
  SearchClear() {
    this.userForm.reset();
    this.userForm.controls["RECORD_STATE"].setValue(101);

  }

  AdvanceSearch() {
    let FormData = this.userForm.getRawValue();
    if (FormData["RECORD_STATE"] == null || FormData["RECORD_STATE"] == undefined) {
      FormData["RECORD_STATE"] = 101;
    }
    this.summaryService.getUserSearchSummary(FormData).subscribe(summary => {
      //this.rowData = summary;
      this.rowData = this.setRowOperations(summary);
    });
  }

  Resend(RecordData: any) {
    let id = RecordData["ID"];
    this['self'].summaryService.resendUserEmail(id, "1").subscribe(summary => {
      if (summary != null && summary.Status == 0) {
        this['self'].commonService.SuccessBanner(summary.Message);
      } else if (summary.ErrorCode == "MAILEXCEPTION") {
        this['self'].commonService.ValidationBanner("Unable to send email to users. Please try again");
      }
    });
  }

  Refresh(RecordData: any) {
    let row = RecordData;
    this.UserName = row.TITLE;
    var user = new UserInfo;
    user["ID"] = row.ID;
    user["Username"] = row.EMAIL;
    user["Email"] = row.EMAIL;
    user["OrgId"] = row.ORGANIZATION_ID;
    this['self'].summaryService.refreshUser(user).subscribe(response => {
      if (response.Status == 0) {
       
        this['self'].commonService.SuccessBanner("Analytics account created successfully for the user " + this.UserName);
        this['self'].setSummary("-1");
      } else {
       
        this['self'].commonService.ValidationBanner("User " + this.UserName + " details saved successfully but the analytics account is not created. Please refresh the details to create an account");
      }
    })
  }
}
